"use strict";

exports.__esModule = true;
exports.ElementEditorController = void 0;
var _react = require("react");
var _Utils = require("../../../../Utils");
var _elementEditorActions = require("./elementEditorActions");
var _excluded = ["children"];
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelperLoose(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (t) return (t = t.call(r)).next.bind(t); if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var o = 0; return function () { return o >= r.length ? { done: !0 } : { done: !1, value: r[o++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var createState = function createState(props) {
  var onChange = props.onChange,
    rootElement = props.rootElement,
    widgets = props.widgets,
    userActions = props.userActions;
  var components = {};
  var editorComponents = {};
  for (var _iterator = _createForOfIteratorHelperLoose(widgets), _step; !(_step = _iterator()).done;) {
    var widget = _step.value;
    components[widget.name] = widget.components.Editable || widget.components.Element;
    if (widget.components.Fields) {
      editorComponents[widget.name] = widget.components.Fields;
    }
  }
  return {
    onChange: onChange,
    rootElement: rootElement,
    widgets: widgets,
    components: components,
    editorComponents: editorComponents,
    userActions: userActions,
    selectedPath: [],
    isDragging: false,
    isSaveTemplateDialogOpen: false,
    isChooseTemplateDialogOpen: false
  };
};
var ElementEditorController = exports.ElementEditorController = /*#__PURE__*/function (_Component) {
  function ElementEditorController() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = (0, _Utils.createControllerState)(_this, createState, _elementEditorActions.elementEditorActions);
    return _this;
  }
  _inheritsLoose(ElementEditorController, _Component);
  ElementEditorController.getDerivedStateFromProps = function getDerivedStateFromProps(props, prevState) {
    if (props.rootElement === prevState.rootElement) {
      return null;
    }
    // eslint-disable-next-line no-unused-vars
    var children = props.children,
      extra = _objectWithoutPropertiesLoose(props, _excluded);
    return extra;
  };
  var _proto = ElementEditorController.prototype;
  _proto.render = function render() {
    return this.props.children(this.state);
  };
  return ElementEditorController;
}(_react.Component);